import { render, staticRenderFns } from "./BlockModels.vue?vue&type=template&id=55b13e1a&scoped=true&lang=pug"
import script from "./BlockModels.vue?vue&type=script&lang=js"
export * from "./BlockModels.vue?vue&type=script&lang=js"
import style0 from "./BlockModels.vue?vue&type=style&index=0&id=55b13e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b13e1a",
  null
  
)

export default component.exports